import styled from 'styled-components';
import { Theme } from '../theme';
import { darken } from '../../utils/polished';
import { IProps } from './Badge';

export const BadgeElement = styled.div<IProps>`
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  color: ${props => getColor(props, props.theme)};
  background-color: ${props => getBgColor(props, props.theme)};
  border: 1px solid ${props => getBorderColor(props, props.theme)};
  padding: ${({ size }) => (size === 'small' ? '0 1rem' : '0 1.6rem')};
  height: ${({ size }) => (size === 'small' ? '2.6rem' : '3.2rem')};
  cursor: ${props => (props.onClick ? 'pointer' : 'default')};
  transition: all 0.2s ease-in;
  font-size: 1.4rem;
  font-weight: ${({ size }) => (size === 'small' ? '600' : '500')};
  border-radius: ${({ rounded }) => (rounded && typeof rounded == 'number' ? `${rounded}px` : rounded ? '12px' : '0')};
  &:hover {
    background-color: ${props =>
      props.onClick ? darken(0.1, getBgColor(props, props.theme)) : getBgColor(props, props.theme)};
  }
`;

export const BadgeContent = styled.div`
  margin-right: 10px;
` as any;

export const BadgeIcon = styled.div`` as any;

function getColor(props: IProps, theme: Theme) {
  if (props.color) {
    return 'white';
  } else {
    switch (props.variation) {
      case 'normal':
      case 'basic':
      case 'outline':
      default:
        return theme.vars.newColor.darkGS2;
    }
  }
}

export function getIconColor(props: IProps, theme: Theme) {
  if (props.iconColor) {
    return props.iconColor;
  } else {
    return getColor(props, theme);
  }
}

function getBgColor(props: IProps, theme: Theme) {
  if (props.color) {
    return props.color;
  } else {
    switch (props.variation) {
      case 'normal':
      default:
        return theme.vars.newColor.lightGS1;
      case 'outline':
        return 'transparent';
      case 'basic':
        return theme.vars.newColor.lightGS2;
      case 'clean':
        return theme.vars.newColor.white;
    }
  }
}

function getBorderColor(props: IProps, theme: Theme) {
  if (props.borderColor) {
    return props.borderColor;
  } else {
    if (props.color) {
      return props.color;
    } else if (props.variation === 'clean') {
      return theme.vars.newColor.white;
    } else if (props.variation === 'outline') {
      return theme.vars.newColor.lightGS1;
    } else {
      return getBgColor(props, theme);
    }
  }
}
